module.exports = __webpack_public_path__ + "assets/img/987374d6c8a4f5a74c98f578f29ebf9b.svg";